import * as React from 'react';
import classnames from 'classnames';
import { Breadcrumbs } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { Types } from '@grandvisionhq/graphql';
import { Alert } from '@grandvisionhq/iris-ui';
import { Location, Types as Types$1, OpeningHours } from '@grandvisionhq/locations';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import SimpleBreadcrumb from '../../components/SimpleBreadcrumb/SimpleBreadcrumb.js';
import '@swc/helpers';
import '../../components/PreferredStoreFinder/PreferredStoreFinder.js';
import '../../components/StoreRating/StoreRating/Star.js';
import '@grandvisionhq/icons';
import StoreBookAppointmentCTAContainer from '../../components/StoreBookAppointmentCTA/StoreBookAppointmentCTAContainer.js';
import StoreFacilitiesContainer from '../../components/StoreFacilities/StoreFacilitiesContainer.js';
import '@grandvisionhq/analytics';
import '../../context/StoreFinder/context.js';
import { areServicesAvailable } from '../../utils/store-utils.js';
import 'lodash/deburr';
import { getActiveCampaignBanner } from '../../utils/get-active-campaign-banner.js';
import { getActiveStoreOffers } from '../../utils/get-active-store-offers.js';
import '../../context/StoreFinderSlots/context.js';
import '@grandvisionhq/utils';
import StoreDetailImageContainer from '../../components/StoreDetailImage/StoreDetailImageContainer.js';
import StoreDescriptionContainer from '../../components/StoreDescription/StoreDescriptionContainer.js';
import StoreDistance from '../../components/StoreDistance/StoreDistanceContainer.js';
import StoreFranchiseIndicatorContainer from '../../components/StoreFranchiseIndicator/StoreFranchiseIndicatorContainer.js';
import StoreLocationContainer from '../../components/StoreLocation/StoreLocationContainer.js';
import StoreBrandContainer from '../../components/StoreBrands/StoreBrandsContainer.js';
import StorePaymentMethodsContainer from '../../components/StorePaymentMethods/StorePaymentMethodsContainer.js';
import StoreSocialMediaContainer from '../../components/StoreSocialMedia/StoreSocialMediaContainer.js';
import '@grandvisionhq/svc-tealium/events';
import '../../operations/queries/get-place-by-id.js';
import '../../operations/queries/get-stores-by-distance.js';
import '../../operations/queries/get-store-by-id.js';
import '../../operations/queries/get-store-details.js';
import '../../operations/queries/get-nearest-stores.js';
import '../../operations/queries/get-preferred-store.js';
import '../../operations/queries/get-preferred-store-id.js';
import '../../operations/queries/get-preferred-store-code.js';
import '../../operations/queries/stores-search.js';
import '../../types.js';
import '@grandvisionhq/fun-store-filters';
import '../../operations/mutations/update-personal-details.js';
import StoreOffersContainer from '../../components/StoreOffers/StoreOffersContainer.js';
import StoreOpticiansContainer from '../../components/StoreOpticians/StoreOpticiansContainer.js';
import StoreCategoriesContainer from '../../components/StoreCategories/StoreCategoriesContainer.js';
import { StoreRatingContainer } from '../../components/StoreRating/StoreRatingContainer.js';
import '@grandvisionhq/auth';
import useIsInViewport from '../../hooks/useIsInViewport.js';
import usePreferredStore from '../../hooks/use-preferred-store.js';
import { NearbyStoresContainer } from '../../components/NearbyStores/NearbyStoresContainer.js';

const StoreDetailsRoot = ({ store , opco , hidePhone , hideEmail , breadcrumbs , urls , appointmentTypeId , logos , dropInAppointmentBookingWidget: DropInWidget = null , nearestStores =[] , campaignBanner , productCategories , preferredStoreButton ,  })=>{
    var ref, ref1, ref2;
    const { getFormattedLabel  } = useIntl();
    const { featureConfigs: { storeDistanceConfig  } = {}  } = useFeatureToggles();
    const canShowBookAppointmentWidget = areServicesAvailable(store, [
        Types.ServicesNotAvailable.APPOINTMENTS
    ]) && Boolean((ref = urls.bookAppointment) === null || ref === void 0 ? void 0 : ref.length);
    const showBookAppointmentDropInWidget = canShowBookAppointmentWidget && Boolean(appointmentTypeId === null || appointmentTypeId === void 0 ? void 0 : appointmentTypeId.length) && DropInWidget;
    const showBookAppointmentCTA = canShowBookAppointmentWidget && !showBookAppointmentDropInWidget;
    const { name , code , globalStoreId , shortName , description , detailImage , emailAddress , phone , streetName , streetNumber , postalCode , town , province , country , additionalStreetInfo , lat , lon , storeNote , openingHours , specialOpeningHours , facilities , brands , paymentMethods , socialMediaLinks , opticians , offers , wheelchairAccessible , storeProductCategories , hearingAppointmentPossible , isFranchiseStore ,  } = store;
    const bookAppointmentButtonRef = React.useRef(null);
    const dropInWidgetRef = React.useRef(null);
    const isBookAppointmentButtonInViewport = useIsInViewport(bookAppointmentButtonRef);
    const isDropInWidgetInViewport = useIsInViewport(dropInWidgetRef);
    const storeCategories = getActiveStoreOffers(productCategories, storeProductCategories);
    const activeCampaignBanner = getActiveCampaignBanner(campaignBanner, {
        globalStoreId
    });
    const { preferredStoreUpdated , preferredStoreSuccess , preferredStoreAlertLabel  } = usePreferredStore(shortName !== null && shortName !== void 0 ? shortName : name);
    const hideStickyBookAppointmentButton = isBookAppointmentButtonInViewport || isDropInWidgetInViewport;
    const showPaymentMethods = !!paymentMethods && !!(logos === null || logos === void 0 ? void 0 : logos.paymentMethods) && paymentMethods.length > 0 && logos.paymentMethods.length > 0;
    const showSocialMedia = !!socialMediaLinks && !!(logos === null || logos === void 0 ? void 0 : logos.socialMedia) && socialMediaLinks.length > 0 && logos.socialMedia.length > 0;
    const addressData = React.useMemo(()=>({
            additionalStreetInfo,
            streetName,
            streetNumber,
            postalCode,
            town,
            province
        })
    , [
        additionalStreetInfo,
        streetName,
        streetNumber,
        postalCode,
        town,
        province
    ]);
    const distanceDetails = React.useMemo(()=>storeDistanceConfig ? /*#__PURE__*/ React.createElement(StoreDistance, {
            globalStoreId: globalStoreId
        }) : null
    , [
        globalStoreId,
        storeDistanceConfig
    ]);
    const labels = React.useMemo(()=>{
        const label = getFormattedLabel('stores.storeDetailsRoot.announcement', {
            hideLabelKey: true,
            parseLink: true
        });
        if (!label) {
            return {};
        }
        return {
            storeAnnouncement: label
        };
    }, [
        getFormattedLabel
    ]);
    var ref3, _bookAppointment, _bookAppointment1;
    return /*#__PURE__*/ React.createElement("article", {
        className: "store-details-stores-v2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__top-wrapper"
    }, preferredStoreUpdated ? /*#__PURE__*/ React.createElement(Alert, {
        variant: preferredStoreSuccess ? 'success' : 'warning',
        className: "alert-m-default"
    }, preferredStoreAlertLabel) : null, /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__top-row"
    }, breadcrumbs && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__breadcrumbs"
    }, /*#__PURE__*/ React.createElement(Breadcrumbs, {
        pages: breadcrumbs
    })), breadcrumbs.length >= 2 && /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__breadcrumb"
    }, /*#__PURE__*/ React.createElement(SimpleBreadcrumb, {
        title: (ref3 = (ref1 = breadcrumbs[1]) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref3 !== void 0 ? ref3 : '',
        href: (ref2 = breadcrumbs[1]) === null || ref2 === void 0 ? void 0 : ref2.url
    }))), preferredStoreButton ? preferredStoreButton : null)), /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__content-wrapper"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__main-content-wrapper"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__main-content"
    }, /*#__PURE__*/ React.createElement(StoreDetailImageContainer, {
        className: "store-details-stores-v2__detail-image",
        detailImageUrl: detailImage,
        fallbackImage: urls.storeFallbackImage,
        alt: shortName || name
    }), /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__contact-info"
    }, /*#__PURE__*/ React.createElement(Location, {
        className: "store-details-stores-v2__location",
        id: globalStoreId,
        name: name,
        variant: Types$1.LocationVariant.StandAlone,
        emailAddress: emailAddress,
        phone: phone,
        emailHidden: hideEmail,
        phoneHidden: hidePhone,
        locationDetailsUrl: '',
        headerImage: activeCampaignBanner,
        highlight: false,
        addressData: addressData,
        addressSize: "COMPLETE",
        wheelchairAccessible: wheelchairAccessible,
        hearingAppointmentPossible: hearingAppointmentPossible,
        isFranchiseStore: isFranchiseStore,
        distanceDetails: distanceDetails,
        openingHours: /*#__PURE__*/ React.createElement(OpeningHours, {
            withTitle: true,
            announcement: storeNote,
            openingHours: openingHours,
            specialOpeningHours: specialOpeningHours,
            isExpandable: false,
            isExpanded: true
        }),
        buttons: /*#__PURE__*/ React.createElement(React.Fragment, null, showBookAppointmentDropInWidget ? /*#__PURE__*/ React.createElement("div", {
            className: "store-details-stores-v2__drop-in-widget-container",
            ref: dropInWidgetRef
        }, /*#__PURE__*/ React.createElement(DropInWidget, {
            urls: urls,
            storeId: globalStoreId,
            typeId: appointmentTypeId,
            dataLayerEvents: {
                storeAppointmentClickEvent: 'storeDetailsFastAppointmentClick',
                storeChangeAppointmentTypeClickEvent: 'storeDetailsChangeClick'
            }
        })) : null, showBookAppointmentCTA ? /*#__PURE__*/ React.createElement("div", {
            ref: bookAppointmentButtonRef,
            className: "store-details-stores-v2__book-appointment"
        }, /*#__PURE__*/ React.createElement(StoreBookAppointmentCTAContainer, {
            url: (_bookAppointment = urls.bookAppointment) !== null && _bookAppointment !== void 0 ? _bookAppointment : '',
            globalStoreId: globalStoreId,
            code: code,
            name: name,
            town: town,
            country: country,
            streetName: streetName,
            streetNumber: streetNumber,
            additionalStreetInfo: additionalStreetInfo,
            postalCode: postalCode,
            appointmentTypeId: appointmentTypeId
        })) : null, (showBookAppointmentDropInWidget || showBookAppointmentCTA) && labels.storeAnnouncement && /*#__PURE__*/ React.createElement(Text, {
            variant: "caption",
            children: labels.storeAnnouncement
        }))
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__secondary-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__location"
    }, /*#__PURE__*/ React.createElement(StoreLocationContainer, {
        opco: opco,
        globalStoreId: globalStoreId,
        name: name,
        town: town,
        province: province,
        country: country,
        streetName: streetName,
        streetNumber: streetNumber,
        additionalStreetInfo: additionalStreetInfo,
        postalCode: postalCode,
        lat: lat,
        lon: lon,
        distanceDetails: distanceDetails,
        practicalInformation: store.practicalInformation
    })), facilities && facilities.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__facilities"
    }, /*#__PURE__*/ React.createElement(StoreFacilitiesContainer, {
        facilities: facilities
    })), /*#__PURE__*/ React.createElement(StoreRatingContainer, {
        store: store
    }), offers && offers.length > 0 && /*#__PURE__*/ React.createElement(StoreOffersContainer, {
        className: "store-details-stores-v2__store-offers",
        fallbackImage: urls.offerFallbackImage,
        offers: offers
    }), nearestStores.length > 0 && /*#__PURE__*/ React.createElement(NearbyStoresContainer, {
        className: "store-details-stores-v2__nearest-stores",
        stores: nearestStores,
        urls: urls,
        storeDetails: store
    }), storeCategories && storeCategories.length > 0 && /*#__PURE__*/ React.createElement(StoreCategoriesContainer, {
        className: "store-details-stores-v2__store-product-groups",
        fallbackImage: urls.productCategoryFallbackImage,
        storeCategories: storeCategories
    }), /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__description"
    }, /*#__PURE__*/ React.createElement(StoreDescriptionContainer, {
        storeName: name,
        description: description
    }), isFranchiseStore && /*#__PURE__*/ React.createElement(StoreFranchiseIndicatorContainer, null)), opticians && opticians.length > 0 && /*#__PURE__*/ React.createElement(StoreOpticiansContainer, {
        className: "store-details-stores-v2__store-opticians",
        fallbackImage: urls.offerFallbackImage,
        opticians: opticians
    }), brands && brands.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__brands"
    }, /*#__PURE__*/ React.createElement(StoreBrandContainer, {
        brands: brands
    })), /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__payment-methods-social-media"
    }, showPaymentMethods && !!logos && /*#__PURE__*/ React.createElement(StorePaymentMethodsContainer, {
        className: "store-details-stores-v2__payment-methods",
        logos: logos.paymentMethods,
        paymentMethods: paymentMethods
    }), showSocialMedia && !!logos && /*#__PURE__*/ React.createElement(StoreSocialMediaContainer, {
        className: "store-details-stores-v2__social-media",
        logos: logos.socialMedia,
        socialMediaLinks: socialMediaLinks
    })))), /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__side-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "store-details-stores-v2__detail-image"
    }, /*#__PURE__*/ React.createElement(StoreDetailImageContainer, {
        detailImageUrl: detailImage,
        fallbackImage: urls.storeFallbackImage,
        alt: shortName || name
    })), /*#__PURE__*/ React.createElement(StoreRatingContainer, {
        store: store
    }), offers && offers.length > 0 && /*#__PURE__*/ React.createElement(StoreOffersContainer, {
        className: "store-details-stores-v2__store-offers",
        fallbackImage: urls.offerFallbackImage,
        offers: offers
    }), nearestStores.length > 0 && /*#__PURE__*/ React.createElement(NearbyStoresContainer, {
        className: "store-details-stores-v2__nearest-stores",
        stores: nearestStores,
        urls: urls,
        storeDetails: store
    }), storeCategories && storeCategories.length > 0 && /*#__PURE__*/ React.createElement(StoreCategoriesContainer, {
        className: "store-details-stores-v2__store-product-groups",
        fallbackImage: urls.productCategoryFallbackImage,
        storeCategories: storeCategories
    }), showPaymentMethods && logos && /*#__PURE__*/ React.createElement(StorePaymentMethodsContainer, {
        logos: logos.paymentMethods,
        paymentMethods: paymentMethods
    }), showSocialMedia && logos && /*#__PURE__*/ React.createElement(StoreSocialMediaContainer, {
        logos: logos.socialMedia,
        socialMediaLinks: socialMediaLinks
    }))), showBookAppointmentCTA && /*#__PURE__*/ React.createElement("div", {
        "data-t": "cta-sticky-footer",
        className: classnames('store-details-stores-v2__sticky-footer', {
            'store-details-stores-v2__sticky-footer--hidden': hideStickyBookAppointmentButton
        })
    }, /*#__PURE__*/ React.createElement(StoreBookAppointmentCTAContainer, {
        url: (_bookAppointment1 = urls.bookAppointment) !== null && _bookAppointment1 !== void 0 ? _bookAppointment1 : '',
        code: code,
        globalStoreId: globalStoreId,
        name: name,
        town: town,
        country: country,
        streetName: streetName,
        streetNumber: streetNumber,
        additionalStreetInfo: additionalStreetInfo,
        postalCode: postalCode,
        appointmentTypeId: appointmentTypeId
    })));
};

export { StoreDetailsRoot as default };
//# sourceMappingURL=StoreDetailsRoot.js.map
